import { Grid, type GridProps } from '@chakra-ui/react';

export type UiGridProps = GridProps;

export const UiGrid = Grid;
